/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:37:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:09:52                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * TechnicianDashCard - Display technician
*/

/* Imports */
import { EnvelopeIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
/***/

/* Styles */
import "./TechnicianDashCard.scss";
import TechnicianDisplay from "./TechnicianDisplay";
/***/

/**
* TechnicianDashCard - Display technician
* @param technician - technician data
* @param onClick - on click event, trigger on component click
*/
export default function TechnicianDashCard({
  technician,
  onClick
}: {
  technician: EasyTech.Technician,
  onClick?: () => void
}) {
  return (
  <div className="technician-card" onClick={() => onClick && onClick()}>
    <div className="icon-text-container">
      <div className="icon-text">
        <TechnicianDisplay technician={technician} />

      </div>
      <div className="icon-text">
        <EnvelopeIcon className="h-[20px] w-[20px] text-gray-400"/>
        <Typography>{technician.email}</Typography>
      </div>
    </div>
  </div>
  );
}
/***/
